module.exports = __webpack_public_path__ + "img/full0-min.5aa2ebb7.png";